import { SALESHEAD_REQUISITION } from "./actionType";

const initialState = {
    requisitionData: [],

};

const salesHead = (state = initialState, action) => {
  switch (action.type) {
    case SALESHEAD_REQUISITION:
       state = {
            ...state,
            requisitionData: action.payload.storedRows,
            productCategory: action.payload.productCategory
          };
      break;  
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default salesHead;
